import { ComponentType } from "react";

type StepComponent = ComponentType<any>;

const componentRegistry: Record<string, StepComponent> = {};

export function registerSteps(components: Record<string, StepComponent>) {
  Object.entries(components).forEach(([type, component]) => {
    componentRegistry[type] = component;
  });
}

export function getStep(type: string) {
  return componentRegistry[type];
}